import { MyError } from "./typing/utils.type";

export const isMyError = (x: unknown): x is MyError => {
  const whatIf = x as MyError;
  return (
    typeof whatIf?.response?.data?.error === "string" ||
    typeof whatIf?.response?.data?.message === "string"
  );
};
